/** CJK Unified Ideographs (common Chinese characters). */
const CHINESE_CHAR_RE = /[\u4e00-\u9fff]/

/**
 * Chinese fields must contain at least one Chinese character.
 * Empty / whitespace-only input is invalid (callers usually check emptiness separately).
 */
export function validateChineseText(text: string): boolean {
  const value = text.trim()
  if (!value) return false
  return CHINESE_CHAR_RE.test(value)
}

/**
 * English fields must not contain Chinese characters.
 * Empty / whitespace-only input is invalid (callers usually check emptiness separately).
 */
export function validateEnglishText(text: string): boolean {
  const value = text.trim()
  if (!value) return false
  return !CHINESE_CHAR_RE.test(value)
}
